<template>
	<div class="home">
		<div class="wrap-container">
			<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/smart_product' }">智能产品</el-breadcrumb-item>
			</el-breadcrumb>

			<div class="search-box">
				<div class="search-box-nav">
					<el-tabs>
						<el-tab-pane v-for="(item, index) in 3" :key="index">
							<div slot="label">公告</div>
						</el-tab-pane>
					</el-tabs>
				</div>
				<div class="search-box-body">
					<div v-for="(item, index) in 3" :key="index" class="box-body-item">
						<div class="body-item-title">无法接收验证短信/邮件，怎么办？</div>
						<div class="body-item-info">
							您好，如果您需要更改绑定手机，而当前绑定手机号已经停用无法接收验证码，请通过该地址进行帐号找回申诉。按照页面提示输入帐号使用信息，申诉成功后可以为该帐号绑定新的手机号。信息，申诉成功后可以为该帐号绑定新的手机号。信息，申诉成功后可以手机号
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	export default {
		name: 'Home',
		data() {
			return {};
		},
		methods: {},
	};
</script>
<style lang="scss" scoped>
	.wrap-container {
		position: relative;
		box-sizing: border-box;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
		background-color: #f5f5f5;

		.bread {
			margin: calc(var(--proportion) * 40px) calc(var(--proportion) * 160px);
			margin-left: 10%;
		}
		.search-box {
			width: 65%;
			margin-left: 17%;
			background-color: #fff;
			background-color: #fff;
			.search-box-nav {
				display: flex;
				justify-content: center;
				border-bottom: 1px solid #eee;
				margin-bottom: 35px;
				padding: 10px;
			}

			.search-box-body {
				padding: 40px 65px;
				height: 500px;
				overflow-y: scroll;
			}
			.box-body-item {
				border-bottom: 1px solid #eeee;
				padding-bottom: 15px;
				margin-bottom: 35px;
				.body-item-title {
					font-size: 18px;

					font-weight: bold;
					color: #e60000;
				}
				.body-item-info {
					font-size: 16px;

					font-weight: 400;
					color: #333333;
					margin-top: 10px;
				}
			}
		}
	}
	::v-deep .el-tabs__nav-wrap::after {
		background-color: transparent !important;
		text-align: center;
	}

	::v-deep .el-tabs__item {
		padding: 0 calc(var(--proportion) * 40px);
		font-size: 0.53rem;
		font-family: Alibaba PuHuiTi 2;
		font-weight: normal;
		color: #000 !important;
	}

	::v-deep .el-tabs__active-bar {
		bottom: 2px;
		height: 8px;
		background: #e60000;
	}
</style>
